module.exports = '1.0.3';


/*****************
 ** WEBPACK FOOTER
 ** (webpack)-dev-server/~/sockjs-client/lib/version.js
 ** module id = 239
 ** module chunks = 0
 **/